var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"append",rawName:"v-append",value:(_vm.content),expression:"content"}],staticClass:"goods-content",class:{ 'text-format': _vm.isText ,'need-magin': _vm.needMagin}})
}
var staticRenderFns = []

export { render, staticRenderFns }